export default "__VITE_ASSET__QNwfM3yZ__"